import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RequestedPermissions } from '../../../../models/roles-and-permissions';
import { PermissionService } from '../../../../services/permission/permission.service';
import { ComponentBase } from '../../../../base-classes/componet-base';
import { RoutingService } from '../../../../services/routing-service/routing.service';
import { PrifactRoute } from '../../../../models/prifact-route';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.css']
})
export class AuthorizeComponent extends ComponentBase implements OnInit {

  @Input() requestedAccess: RequestedPermissions;

  constructor(private permissionService: PermissionService
    , private routingService: RoutingService) {
    super();
  }

  ngOnInit() {
    let sub = this.permissionService.getPermissionsForUser()
      .subscribe((res) => {
        if (!res.isAuthorized(this.requestedAccess)) {
          let route = new PrifactRoute();
          route.clear_history = true;
          route.url = "pages/unauthorized";
          this.routingService.navigate(route);
        }
      });
    this.addSubscription(sub);
  }

}
